(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode("#flash-focus-modal-overlay .flash-popover .popover{border:none;min-width:400px}")),document.head.appendChild(e)}}catch(o){console.error("vite-plugin-css-injected-by-js",o)}})();
import { jsx, jsxs } from "react/jsx-runtime";
import { useRef, useEffect, Fragment } from "react";
import FlashButton from "../../components/atoms/buttons/FlashButton/FlashButton.js";
import FlashPopover from "../../components/atoms/popups/FlashPopover/FlashPopover.js";
import { useFlashPopover } from "../../components/atoms/popups/FlashPopover/useFlashPopover.js";
import i18n from "../../i18n/index.js";
import { sass } from "../../sass/sass.js";
import { I as I18nextProvider } from "../../I18nextProvider-16dc4551.js";
import { u as useTranslation } from "../../useTranslation-cf39c293.js";
import "../../index-e71f83b5.js";
import "../../_commonjsHelpers-0c53d963.js";
import "../../components/constants.js";
import "../../components/atoms/info/FlashBadge/FlashBadge.js";
import "../../utils-f8d1c624.js";
import "../../components/atoms/info/FlashSpinner/FlashSpinner.js";
import "../../components/atoms/buttons/FlashButtonGeneric.js";
import "../../index-5e4e4f4b.js";
import "../../axios-5f69b112.js";
import "../../Button-9f0631d3.js";
import "../useInsights/useInsights.js";
import "../../utils/noOp.js";
import "../useLogger/constants.js";
import "../useLogger/useLogger.js";
import "../useLogger/LoggerContext.js";
import "../useLogger/types.js";
import "../useInsights/InsightsContext.js";
import "../useInsights/useInsightsImpression.js";
import "../../index-2d889c01.js";
import "../useInsights/utils.js";
import "../../utils/invokeFn.js";
import "../../components/atoms/buttons/FlashButton/constants.js";
import "../../TooltipPopoverWrapper-c4dc3a40.js";
import "react-dom";
import "../../Popper-b45e70f5.js";
import "../../Manager-52cb3832.js";
import "../../Fade-1a465599.js";
import "../../Transition-c07376a3.js";
import "../useOutsideClickHandler/useOutsideClickHandler.js";
import "../../i18n/translations/en.js";
import "../../i18n/translations/es.js";
import "../../i18nInstance-89725fcb.js";
const BACKDROP_OPACITY = 80;
function FlashFocusModal(props) {
  const {
    targetNode,
    targetId,
    placement,
    onDismiss,
    hasNext,
    onNext,
    movingToNext,
    targetZIndex,
    title,
    Body,
    progressText
  } = props, containerRef = useRef(null), popoverProps = useFlashPopover({ closeOnOutsideClick: !1 });
  return useEffect(
    () => {
      if (!targetNode) {
        popoverProps.close();
        return;
      }
      popoverProps.open();
    },
    /* eslint-disable-next-line react-hooks/exhaustive-deps --
     *  Only need to update when the targetNode value changes
     */
    [!targetNode]
  ), /* @__PURE__ */ jsx(
    "div",
    {
      id: "flash-focus-modal-overlay",
      ref: containerRef,
      className: "vh-100 vw-100 position-fixed top-0 start-0",
      style: {
        zIndex: targetZIndex - 1,
        backgroundColor: `${sass.color.flash.semantic.surface.inverse}${BACKDROP_OPACITY}`
      },
      children: !movingToNext && !!targetNode && /* @__PURE__ */ jsx(
        FlashPopover,
        {
          ...popoverProps,
          container: containerRef,
          target: targetId,
          placement,
          bodyProps: {
            className: "bg-info text-inverse_primary"
          },
          children: /* @__PURE__ */ jsxs("div", { className: "px-flash-200 py-flash-300", children: [
            /* @__PURE__ */ jsx("header", { className: "fs-body-l lh-body-l fw-bold mb-flash-200", children: title }),
            /* @__PURE__ */ jsx("div", { id: "flash-focus-popover-body", className: "mb-flash-200", children: Body }),
            /* @__PURE__ */ jsxs("div", { className: "d-flex gap-flash-300 align-items-center", children: [
              progressText && /* @__PURE__ */ jsx("div", { children: progressText }),
              /* @__PURE__ */ jsx("div", { className: "flex-fill" }),
              /* @__PURE__ */ jsx("div", { className: "justify-self-end d-flex gap-flash-100", children: /* @__PURE__ */ jsx(I18nextProvider, { i18n, children: /* @__PURE__ */ jsx(FocusModalButtons, { onDismiss, hasNext, onNext }) }) })
            ] })
          ] })
        }
      )
    }
  );
}
function FocusModalButtons(props) {
  const { onDismiss, hasNext, onNext } = props, { t } = useTranslation();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(FlashButton, { id: "focus-modal-dismiss-btn", onClick: onDismiss, children: t("FOCUS_MODAL:DISMISS") }),
    hasNext && /* @__PURE__ */ jsx(FlashButton, { id: "focus-modal-next-btn", onClick: onNext, color: "secondary", children: t("FOCUS_MODAL:NEXT") })
  ] });
}
export {
  FlashFocusModal as default
};
//# sourceMappingURL=FlashFocusModal.js.map
